import React, { useEffect } from "react";
import { useArrayContext } from "../../../state/ArrayContext";
import { SourceItem } from "../../../shared/models/source-item.model";
import { ChatbotPromptInfo } from "../../../shared/models/chatbot-history.model";
import { useChatbotHistory } from "../../../state/InternalContext";

/**
 * Array source that returns the chatbot history.
 * @deprecated Use {@link Chatbot} with inline useChat history instead. This component remains for backward-compatible authored HTML.
 */
export const ChatbotHistory = React.memo(function ChatbotHistory(): React.ReactElement {
    const { setArray } = useArrayContext();
    const chatbotHistory = useChatbotHistory();

    useEffect(() => {
        const result: SourceItem[] = chatbotHistory?.prompts?.map((message: ChatbotPromptInfo) => {
            return {
                value: message.response,
                position: chatbotHistory.prompts.indexOf(message) + 1,
                props: {
                    info: {
                        prompt: [message.prompt],
                        response: [message.response],
                        timestamp: ["" + message.timestamp],
                        validity: [message.validity],
                        references: message.references.map((ref) => ref.path),
                        referenceCount: [message.references.length],
                    }
                }
            };
        }) || [];
        setArray(result);
    }, [setArray, chatbotHistory]);

    return <></>;
});